import { IModelEntity } from '@pit/core';
import { IDtoCustomerTransferTime } from './dto.customer.transfertime.interface';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoCustomer extends IModelEntity {

    name?: string;
    numberCustomer?: string;
    costCenterCode?: string;

    mandator?: IDtoMandator;

    transferTimes?: IDtoCustomerTransferTime[];

}
